<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-8
        h1.m-0
          i Reactivar usuario
      .col-4
        .h2.text-right.ad_text-grayLight.m-0
          i.text-capitalize
    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col-12
          .card.p-0.ad_bg-gray.rounded-xl
            .card-body
              form.d-flex.flex-row.flex-wrap
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Nombre
                  input.col.form-control(type="text" v-model="name" maxlength='100' placeholder='ingresa tu nombre' title='ingresa tu nombre')
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Rut
                  input.col.form-control(type="text" v-model="rut" maxlength='10' placeholder='ej. 12345678-5' title='ej. 12345678-5')
                  .col-auto.form-group.align-items-center.mb-0.pr-0(v-if="showControl && consultorControl")
                    label.font-weight-bold.pl-0.m-0 Líder
                    input.d-inline-block.ml-2(type="checkbox" v-model="isLeader" title='Selecciona si será líder')
                .col-6.form-group.align-items-center.mb-4(v-if="isLeader")
                  label.col-3.pl-0.m-0 Etapa
                  input.d-inline-block.ml-2(type="radio" v-model="implementation" value="1")
                  label
                    small Implementación 
                  input.d-inline-block.ml-2(type="radio" v-model="implementation" value="0" checked="checked")
                  label
                    small Mantención
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 E-mail
                  input.col.form-control(type="text" v-model="email" maxlength='100' placeholder='email@mail.com' title='ej. email@mail.com')

                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Perfil
                  .col.px-0.ad_select
                    select(v-model='selectedProfile', @change='changeProfile($event)')
                      option(:value="null" disabled) Selecciona perfil
                      option(:value="profile.value" v-for="profile in profiles") {{profile.label}}
                  .col-auto.form-group.align-items-center.mb-0.pr-0(v-if="showControl")
                    label.font-weight-bold.pl-0.m-0 Administrador
                    input.d-inline-block.ml-2(type="checkbox" v-model="isAdmin" title='Selecciona si será administrador de usuarios')
                
                .col-6.form-group.align-items-center.mb-4(v-if="showControl")
                  label.col-3.pl-0.m-0 Clave
                  input.col.form-control(type="password" v-model="password" maxlength='100' placeholder='ingresa clave' title='ingresa clave')
                .col-6.form-group.align-items-center.mb-4(v-if="showControl")
                  label.col-3.pl-0.m-0 Repetir clave
                  input.col.form-control(type="password" v-model="repeatPassword" maxlength='100' placeholder='repite clave' title='repita clave')
                .col-6.form-group.align-items-center.mb-4(v-if="showControl")
                  label.col-3.pl-0.m-0 Nombre de usuario
                  input.col.form-control(type="text" v-model="username" maxlength='100' placeholder='ingresa nombre de usuario' title='ingresa nombre de usuario')
                
                .col-6.form-group.align-items-center.mb-4(v-if="showControl && consultorControl")
                  label.col-3.pl-0.m-0 Roles
                  multiselect.col.px-0(
                    v-model="selectedMultiRole",
                    :options="todosMultiRole",
                    :multiple="true",
                    :close-on-select="false",
                    :clear-on-select="false",
                    :preserve-search="true",
                    placeholder="Seleccione Roles",
                    label="label",
                    track-by="value",
                    :preselect-first="false")
                
                .col-6.form-group.align-items-center.mb-4(v-if="showControl")
                  label.col-3.pl-0.m-0 Colaboradores
                  multiselect.col.px-0(
                    v-model="selectedMultiCollabs",
                    :options="todosMultiCollabs",
                    :multiple="true",
                    :close-on-select="false",
                    :clear-on-select="false",
                    :preserve-search="true",
                    placeholder="Seleccione Colaboradores",
                    label="label",
                    track-by="value",
                    :preselect-first="false")
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Jefe
                  multiselect.col.px-0(
                    v-model="selectedMultiBoss",
                    :options="leaders",
                    :multiple="true",
                    :close-on-select="false",
                    :clear-on-select="false",
                    :preserve-search="true",
                    placeholder="Seleccione Jefe",
                    label="label",
                    track-by="value",
                    :preselect-first="false")    
          .d-flex.flex-row.mt-5
            .col-auto.stepper-button.previous
              router-link(to="/administracion/id/usuarios")
                i.material-icons
                span Volver
            button.col-auto.stepper-button.next.ml-auto(@click="setUser()")
              span Reactivar
              i.material-icons

    b-modal(:id='infoModal.id', centered, modal-class='modal-popUp', title-tag='div',header-class='d-flex', footer-class='d-flex flex-row flex-wrap')
      <template v-slot:modal-title>
        h3.font-weight-bold.mb-0 {{infoModal.title}}
      </template>
      p.text-center {{ infoModal.content }}
      <template v-slot:modal-footer="{ ok, cancel, hide }">
        .col-12.d-flex.justify-content-around
            b-button.px-4(size="lg", variant="danger", @click="$bvModal.hide(infoModal.id)")
              | No
            b-button.px-4(size="lg", variant="success", @click="detailReactivation()")
              | Ver detalle
      </template>

</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapActions } from 'vuex';
import { nullLiteralTypeAnnotation } from 'babel-types';
export default {
  name: 'AdministracionUsuariosReact',
  components: {
     Multiselect
  },
  data () {
    return {
      name: null,
      username: null,
      password: null,
      repeatPassword: null,
      rut: null,
      isLeader: false,
      email: null,
      isAdmin: false,
      selectedProfile: null,
      profiles: null,
      selectedMultiCollabs: [],
      todosMultiCollabs: [],
      selectedMultiRole: [],
      todosMultiRole: [],
      showControl: false,
      consultorControl: false,
      implementation: null,
      infoModal: {
        id: 'check-before-eval',
        title: '¡Atención!',
        content: ''
      },
      selectedMultiBoss: []
    }
  },
  methods: {
    ...mapActions('profile', [
      'profileList'
    ]),
    ...mapActions('travel', [
      'travelList'
    ]),
    ...mapActions('segment', [
      'ByTravelIds'
    ]),
    ...mapActions('product', [
      'BySegmentIds'
    ]),
    ...mapActions('user', [
      'updateUser',
      'getUsers',
      'getRoles',
      'getUserByRut',
    ]),
    getValuesOfMultiSelect(valuesMultiSelect) {
      return valuesMultiSelect.map(values => values.value)
    },
    getItemsToMultiSelectLoad(items) {
      return items.map(p => ({value: p.id, label: p.name, profile: p.profilename, leader: p.leader}))
    },
    getSelectedAfterChangedParent(todos, oldSelectedItems) {
      return todos.filter(t => oldSelectedItems.map(o => o.value).includes(t.value))
    },
    getValueImplementation() {
      const vm = this
      return vm.implementation == '1' ? true: false
    },
    getUserFromProps() {
      const vm = this
      return {
        id: vm.id,
        name: vm.name,
        username: vm.username,
        password: vm.password,
        rut: vm.rut,
        leader: vm.isLeader,
        email: vm.email,
        isAdmin: vm.isAdmin,
        profile: vm.selectedProfile,
        collabs: vm.getValuesOfMultiSelect(vm.selectedMultiCollabs),
        role: vm.getValuesOfMultiSelect(vm.selectedMultiRole),
        implementation: vm.getValueImplementation(vm.implementation),
        isDeleted: false,
        boss: vm.getValuesOfMultiSelect(vm.selectedMultiBoss)
      }
    },
    loadControls() {
      const vm = this
      const loading = vm.$toast.loading('Cargando ...')
      vm.loadProfiles()
      vm.loadCollabs()
      vm.loadRole()
      loading.hide()
    },
    onlyCollabsActives(items) {
      return items.filter(u => u.isDeleted === false).sort((a, b) => a.name.trim().localeCompare(b.name.trim()))
    },
    loadCollabs() {
      const vm = this
      vm.getUsers({}).then(response => {
        vm.todosMultiCollabs = vm.getItemsToMultiSelectLoad(vm.onlyCollabsActives(response))
      })
    },
    loadRole() {
      const vm = this
      vm.getRoles({}).then(response => {
        vm.todosMultiRole = vm.getItemsToMultiSelectLoad(response)
      })
    },
    loadProfiles() {
      const vm = this
      vm.profileList().then(response => {
        vm.profiles = vm.getItemsToMultiSelectLoad(response)
        vm.changeProfile()
      })
    },
    notify(error = true, message) {
      const vm = this
      vm.$notify({
          type: error ? 'danger' : 'success',
          title: 'Notificación',
          content: message,
          closeable: true,
          duration: 5000
        })
    },
    clearInputs() {
      const vm = this
      vm.name = ''
      vm.username = ''
      vm.password = ''
      vm.repeatPassword = ''
      vm.rut = ''
      vm.isLeader = false,
      vm.email = ''
      vm.isAdmin = false
      vm.selectedProfile = null
      vm.changeProfile(vm.selectedProfile)
      vm.selectedMultiCollabs = []
      vm.selectedMultiRole = []
      vm.implementation = null
    },
    setUser() {
      const vm = this
      const loading = vm.$toast.loading('Guardando...')
      if (vm.validate()) {
        const userdata = vm.getUserFromProps()
        vm.updateUser(userdata).then(result => {
          if (!result.success) {
            loading.hide()
            vm.notify(true, result.message)
          } else {
            loading.hide()
            vm.notify(false, 'Usuario reactivado')
          }
        }).catch(error => {
          loading.hide()
          vm.notify(true, error.payload.message)
        })
      } else {
        loading.hide()
      }
    },
    isThecnicalOrCollab() {
      const vm = this
      return ['5cd08f620dbf793238fd3274','5cd8f7002e7122d70e3e8c73'].includes(vm.selectedProfile)
    },
    isConsultor() {
      const vm = this
      return '5d5fc8c37a039508e3303629' == vm.selectedProfile
    },
    changeProfile($event) {
      const vm = this
      const canVisibleAllControls = !vm.isThecnicalOrCollab()
      vm.showControl = canVisibleAllControls
      vm.consultorControl = !vm.isConsultor()
      if (vm.isConsultor()) {
        vm.todosMultiCollabs = vm.todosMultiCollabs.filter(collab => {
          let val = (collab.profile != ("Técnico" || "Colaborador") && collab.leader == true) ? true : false
          return val
        })
      } else {
        vm.loadCollabs()
      }
    },
    isValidInput(input) {
      return input !== undefined && input !== null && input.length > 0
    },
    isSamePassword() {
      const vm = this
      return vm.password.trim() === vm.repeatPassword.trim()
    },
    isValidEmail: function (email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    isValidRut(rut) {
      const re = /[0-9]{7,8}-[0-9Kk]{1}/
      return re.test(rut)
    },
    validate() {
      const vm = this
      let valid = true
      let missing = ''
      const isThecnicalOrCollab = vm.isThecnicalOrCollab()
      
      if (!vm.isValidInput(vm.name)) {
        missing = 'nombre'
        valid = false
      } else if (!vm.isValidInput(vm.rut)) {
        missing = 'rut'
        valid = false
      } else if (!vm.isValidRut(vm.rut)) {
        missing = 'rut con uno válido.'
        valid = false
      } else if (!vm.isValidInput(vm.email)) {
        missing = 'email'
        valid = false
      } else if (!vm.isValidEmail(vm.email)) {
        missing = 'email con uno válido.'
        valid = false
      } else if (!vm.isValidInput(vm.selectedProfile)) {
        missing = 'perfil'
        valid = false
      }

      if (valid && !isThecnicalOrCollab && vm.consultorControl) {
        if (!vm.isValidInput(vm.password)) {
          missing = 'clave'
          valid = false
        } else if (!vm.isValidInput(vm.repeatPassword)) {
          missing = 'repetir clave'
          valid = false
        } else if (!vm.isSamePassword()) {
          missing = 'clave. Debe ser igual a repetir clave'
          valid = false
        } else if (!vm.isValidInput(vm.username)) {
          missing = 'nombre de usuario'
          valid = false
        } else if (!vm.isValidInput(vm.selectedMultiRole)) {
          missing = 'roles'
          valid = false
        } else if (!vm.isValidInput(vm.selectedMultiCollabs)) {
          missing = 'colaboradores'
          valid = false
        } else if (vm.isLeader && vm.implementation == null) {
          missing = 'etapa'
          valid = false
        }
      }

      if (valid) {
        return true
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: `Debe completar el campo ${missing}`,
          closeable: true,
          duration: 5000
        })
        return false
      }
    },
    askForReactivation(content) {
      const vm = this
      vm.$bvModal.show(vm.infoModal.id)
      vm.infoModal.content = content
      // vm.reopenModal.userId = item.id
    },
    detailReactivation() {
      //redirect to reactivate
    },
    loadDetail(rut) {
      const vm = this
      const loading = vm.$toast.loading('Cargando Detalle...')
      const user = vm.$store.getters['auth/getUserInfo']
      vm.getUserByRut(rut).then(user => {
        vm.setUserProps(user)
        vm.loadControls()
        loading.hide()
      }).catch(error => {
        vm.notify(error)
        loading.hide()
      })
    },
    setUserProps(user) {
      const vm = this
      vm.id = user.id,
      vm.name = user.name
      vm.username = user.username
      // vm.password = user.password
      // vm.repeatPassword = user.password
      vm.rut = user.rut
      vm.isLeader = user.leader === undefined ? false : user.leader
      vm.email = user.email
      vm.isAdmin = user.isAdmin === undefined ? false : user.isAdmin
      vm.selectedProfile = user.profile._id
      vm.changeProfile(vm.selectedProfile)
      vm.selectedMultiCollabs = vm.getItemsToMultiSelectLoad(user.collabs)
      vm.selectedMultiRole = vm.getItemsToMultiSelectLoad(user.role)
      vm.implementation = vm.getValueImplementation(user.implementation)
    }
  },
  mounted() {
    const vm = this;
    vm.loadDetail(this.$route.params.id)
    this.$emit('can-continue', { value: true })
  }
}
</script>

<style lang="css" scoped></style>


// WEBPACK FOOTER //
// src/views/administracion-usuarios-reactivate.vue